

// Import ----------------------------------------------------------------------

// Project
import Utils from "~/libs/Utils";
import { VueGlobalInjectable } from "~/libs/Types";

// Export ----------------------------------------------------------------------

export default VueGlobalInjectable.extend({

    // Component imports -------------------------------------------------------

    components: {
        PageImage: () => import("~/components/PageImage.vue"),
        PageComponentList: () => import("~/components/PageComponentList.vue")
    },

    // Component Attribute, Properties & Injected ------------------------------

    inject: ["node"],

    computed: {
        hasPageImage (): boolean {
            return !!this.node.page?.image;
        },

        sectionId (): string {
            return "page-" + Utils.studlyToKebab(this.node.name);
        },

        pageClasses (): Array<string> {
            const classes = ["page"];

            if (this.node.page?.classes) {
                return classes.concat(this.node.page.classes);
            }

            return  classes;
        },

        pageContentClasses (): object {
            return {
                container: true,
                "is-max-desktop": true,
                "with-page-image": this.hasPageImage
            };
        },

        hasPageHeader (): boolean {
            return !!this.pageHeaderComponents;
        },

        hasPageTop (): boolean {
            return !!this.pageTopComponents;
        },

        hasPageBottom (): boolean {
            return !!this.pageBottomComponents;
        },

        hasPageSide (): boolean {
            return !!this.pageSideComponents;
        },

        hasPageFooter (): boolean {
            return !!this.pageFooterComponents;
        },

        showPageSideBar (): boolean {
            return this.hasPageImage || this.hasPageSide;
        },

        pageHeaderComponents (): string[]|null {
            return this.node.page.components?.header ?? null;
        },

        pageTopComponents (): string[]|null {
            return this.node.page.components?.top ?? null;
        },

        pageBottomComponents (): string[]|null {
            return this.node.page.components?.bottom ?? null;
        },

        pageSideComponents (): string[]|null {
            return this.node.page.components?.side ?? null;
        },

        pageFooterComponents (): string[]|null {
            return this.node.page.components?.footer ?? null;
        }
    }

    // -------------------------------------------------------------------------
});
